/**
 * @see https://umijs.org/docs/max/access#access
 * */
export default function access(
  initialState: { currentUser?: API.CurrentUser } | undefined,
) {
  const { currentUser } = initialState ?? {};
  const role = currentUser?.role;

  return {
    canAdmin: role === 'admin' || role === 'civil_admin',
    canAccessAIStats: role === 'admin',
    canAccessImageSync: role === 'admin',
  };
}